import React from "react";
import {  Outlet } from "react-router-dom";
import { useAuth } from "../AuthProvider";

const PrivateRouteManager = () => {
  const authContext = useAuth();
  console.log(authContext.role);
  if (authContext.role==='ROLE_FMANAGER' || authContext.role==='ROLE_CMANAGER' || authContext.role==='ROLE_MANAGER' || authContext.role==='ROLE_SADMIN') 
    return <Outlet />;
};

export default PrivateRouteManager;